import React from 'react';

const HistoricalDataTable = ({ data }) => {
  return (
    <div className="historical-data-container">
      <h2>Historical Gold Prices <span className="currency-badge">INR</span><span className="weight-badge">8g</span></h2>
      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Price (INR)</th>
            </tr>
          </thead>
          <tbody>
            {data.slice().reverse().map((item, index) => (
              <tr key={index}>
                <td>{item.date}</td>
                <td>₹{item.price.toLocaleString('en-IN')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default HistoricalDataTable;